export interface Testimonial {
  id: string;
  userName: string;
  avatar: string;
  content: string;
  role: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 't-1',
    userName: '陈小明',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20Chinese%20man%20portrait%20friendly%20smile%20simple%20background&width=80&height=80&seq=test-avatar-01&orientation=squarish',
    content: '韩漫之家真的是我每天必刷的网站！下拉式阅读体验太棒了，漫画资源丰富更新又快，画质超清晰，看了一年了基本没有断更的漫画。',
    role: '忠实用户 · 使用1年',
    rating: 5,
  },
  {
    id: 't-2',
    userName: '李小萌',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20Chinese%20woman%20portrait%20sweet%20smile%20simple%20background&width=80&height=80&seq=test-avatar-02&orientation=squarish',
    content: '之前试过很多漫画平台，最后还是回到韩漫之家。分类清晰、加载速度快，最重要的是完全免费！推荐给了好多朋友！',
    role: '漫画爱好者',
    rating: 5,
  },
  {
    id: 't-3',
    userName: '王大伟',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mature%20Chinese%20man%20portrait%20confident%20expression%20simple%20background&width=80&height=80&seq=test-avatar-03&orientation=squarish',
    content: '作为一个看了十几年漫画的老读者，韩漫之家的资源库真的让我惊喜。很多小众精品漫画都能找到，而且高清画质看着特别舒服。',
    role: '资深漫迷 · 使用2年',
    rating: 5,
  },
  {
    id: 't-4',
    userName: '张小雪',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cute%20Chinese%20girl%20portrait%20bright%20smile%20simple%20background&width=80&height=80&seq=test-avatar-04&orientation=squarish',
    content: '漫画种类超级丰富！恋爱、悬疑、动作什么类型都有。更新速度也很快，每天都有新章节看，完全停不下来！',
    role: '大学生',
    rating: 5,
  },
  {
    id: 't-5',
    userName: '刘思远',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20stylish%20Chinese%20young%20man%20portrait%20cool%20expression%20simple%20background&width=80&height=80&seq=test-avatar-05&orientation=squarish',
    content: '界面简洁大方，没有乱七八糟的广告。下拉式阅读的设计非常人性化，躺着用手机看漫画体验特别好！',
    role: '上班族',
    rating: 4,
  },
  {
    id: 't-6',
    userName: '赵灵儿',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20gentle%20Chinese%20woman%20portrait%20elegant%20smile%20simple%20background&width=80&height=80&seq=test-avatar-06&orientation=squarish',
    content: '韩漫之家更新漫画的速度真的没话说，经常比我关注的官方账号还快！而且收藏功能很方便，追更不迷路。',
    role: '自由职业者',
    rating: 5,
  },
];

export const aboutStats = [
  { label: '创立时间', value: '2018' },
  { label: '漫画总量', value: '100000+' },
  { label: '注册用户', value: '1000万+' },
  { label: '客服支持', value: '7×24h' },
];

export const milestones = [
  { year: '2018', title: '品牌创立', description: '韩漫之家正式成立，以免费韩漫在线阅读为核心，开启漫画分享之旅。' },
  { year: '2019', title: '用户突破100万', description: '凭借高清漫画资源和流畅的下拉式阅读体验，迅速积累了大量忠实用户。' },
  { year: '2020', title: '漫画总量破万', description: '与多家韩国漫画平台达成合作，漫画资源库突破一万部，涵盖各种类型。' },
  { year: '2022', title: '全球用户破千万', description: '用户覆盖全球多个国家和地区，成为中文韩漫阅读领域的领先平台。' },
  { year: '2024', title: '技术全面升级', description: '全新阅读引擎上线，加载速度提升300%，漫画画质全面高清化。' },
  { year: '2026', title: 'AI智能推荐', description: '引入AI算法，根据用户阅读偏好精准推荐漫画，发现更多喜欢的作品。' },
];